import React, { Component } from 'react'
import appState from '../../../helpers/AppState'

export default class HomePage extends Component {
  render () {
    return (
      <div>
        <h3>Welcome to {appState.appName} app console.</h3>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/HomePage.js